export interface Category {
  key: string;
  url: string;
  icon: string;
  image: string;
}

export const categories: Category[] = [
  {
    key: 'shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    image: 'https://readdy.ai/api/search-image?query=Crisp%20white%20leather%20sneakers%20with%20gum%20sole%20displayed%20on%20a%20soft%20beige%20studio%20backdrop%2C%20single%20pair%20angled%20left%2C%20clean%20minimal%20product%20photography%2C%20soft%20diffused%20natural%20light%2C%20airy%20western%20ecommerce%20aesthetic%2C%20high%20detail&width=400&height=400&seq=cat-shoes-01&orientation=squarish',
  },
  {
    key: 'hoodies',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=Oversized%20sage%20green%20hoodie%20neatly%20folded%20on%20a%20warm%20cream%20studio%20surface%20with%20soft%20shadow%2C%20minimalist%20apparel%20product%20photography%2C%20gentle%20natural%20daylight%2C%20clean%20modern%20western%20aesthetic%2C%20high%20detail&width=400&height=400&seq=cat-hoodies-01&orientation=squarish',
  },
  {
    key: 'tshirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=Stack%20of%20neatly%20folded%20pastel%20cotton%20t-shirts%20in%20cream%20blush%20and%20mint%20on%20a%20light%20neutral%20studio%20background%2C%20minimalist%20clothing%20product%20photography%2C%20soft%20natural%20light%2C%20fresh%20airy%20western%20style%2C%20high%20detail&width=400&height=400&seq=cat-tshirts-01&orientation=squarish',
  },
  {
    key: 'jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-git-commit-line',
    image: 'https://readdy.ai/api/search-image?query=Classic%20washed%20denim%20jacket%20hanging%20on%20a%20wooden%20hanger%20against%20a%20clean%20off-white%20wall%2C%20minimal%20apparel%20product%20photography%2C%20soft%20natural%20window%20light%2C%20modern%20western%20editorial%20aesthetic%2C%20high%20detail&width=400&height=400&seq=cat-jackets-01&orientation=squarish',
  },
  {
    key: 'pants',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-checkbox-blank-line',
    image: 'https://readdy.ai/api/search-image?query=Neatly%20folded%20beige%20cargo%20pants%20and%20khaki%20chino%20shorts%20arranged%20on%20a%20light%20gray%20studio%20surface%2C%20minimalist%20clothing%20product%20photography%2C%20soft%20diffused%20daylight%2C%20clean%20western%20ecommerce%20style%2C%20high%20detail&width=400&height=400&seq=cat-pants-01&orientation=squarish',
  },
  {
    key: 'headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-customer-service-2-line',
    image: 'https://readdy.ai/api/search-image?query=Navy%20baseball%20cap%20with%20minimal%20embroidery%20resting%20on%20a%20soft%20cream%20studio%20pedestal%2C%20clean%20product%20photography%2C%20soft%20natural%20light%2C%20fresh%20modern%20western%20aesthetic%2C%20high%20detail&width=400&height=400&seq=cat-headwear-01&orientation=squarish',
  },
  {
    key: 'sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-stack-line',
    image: 'https://readdy.ai/api/search-image?query=Matching%20sage%20green%20hoodie%20and%20jogger%20tracksuit%20set%20folded%20in%20a%20tidy%20stack%20on%20a%20neutral%20beige%20studio%20background%2C%20minimalist%20apparel%20product%20photography%2C%20soft%20natural%20light%2C%20clean%20western%20style%2C%20high%20detail&width=400&height=400&seq=cat-sets-01&orientation=squarish',
  },
  {
    key: 'underwear',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-archive-line',
    image: 'https://readdy.ai/api/search-image?query=Soft%20cotton%20underwear%20and%20boxers%20neatly%20folded%20in%20a%20small%20stack%20on%20a%20light%20neutral%20studio%20surface%2C%20minimalist%20apparel%20product%20photography%2C%20gentle%20diffused%20light%2C%20clean%20airy%20western%20aesthetic%2C%20high%20detail&width=400&height=400&seq=cat-underwear-01&orientation=squarish',
  },
  {
    key: 'jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-basketball-line',
    image: 'https://readdy.ai/api/search-image?query=Athletic%20basketball%20jersey%20in%20teal%20and%20white%20laid%20flat%20on%20a%20soft%20gray%20studio%20backdrop%2C%20clean%20sportswear%20product%20photography%2C%20soft%20natural%20light%2C%20modern%20western%20ecommerce%20aesthetic%2C%20high%20detail&width=400&height=400&seq=cat-jersey-01&orientation=squarish',
  },
  {
    key: 'accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-vip-diamond-line',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20accessories%20flat%20lay%20with%20a%20leather%20watch%20slim%20sunglasses%20and%20a%20simple%20chain%20necklace%20on%20a%20cream%20studio%20surface%2C%20soft%20natural%20light%2C%20clean%20western%20editorial%20aesthetic%2C%20high%20detail&width=400&height=400&seq=cat-accessories-01&orientation=squarish',
  },
  {
    key: 'bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-handbag-line',
    image: 'https://readdy.ai/api/search-image?query=Brown%20leather%20backpack%20standing%20upright%20on%20a%20soft%20beige%20studio%20surface%20with%20gentle%20shadow%2C%20minimalist%20product%20photography%2C%20soft%20natural%20daylight%2C%20modern%20western%20ecommerce%20aesthetic%2C%20high%20detail&width=400&height=400&seq=cat-bags-01&orientation=squarish',
  },
  {
    key: 'belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-link',
    image: 'https://readdy.ai/api/search-image?query=Rolled%20brown%20and%20black%20leather%20belts%20arranged%20neatly%20on%20a%20light%20neutral%20studio%20background%2C%20minimalist%20accessory%20product%20photography%2C%20soft%20diffused%20light%2C%20clean%20western%20style%2C%20high%20detail&width=400&height=400&seq=cat-belts-01&orientation=squarish',
  },
  {
    key: 'perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-flower-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20amber%20glass%20perfume%20bottle%20with%20minimalist%20label%20on%20a%20soft%20cream%20studio%20pedestal%2C%20clean%20fragrance%20product%20photography%2C%20soft%20natural%20light%2C%20modern%20western%20aesthetic%2C%20high%20detail&width=400&height=400&seq=cat-perfumes-01&orientation=squarish',
  },
  {
    key: 'other',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-more-2-line',
    image: 'https://readdy.ai/api/search-image?query=Assorted%20lifestyle%20accessories%20including%20a%20cap%20socks%20and%20a%20small%20pouch%20arranged%20in%20a%20tidy%20flat%20lay%20on%20a%20neutral%20studio%20background%2C%20minimalist%20product%20photography%2C%20soft%20natural%20light%2C%20clean%20western%20style%2C%20high%20detail&width=400&height=400&seq=cat-other-01&orientation=squarish',
  },
];

export const MAIN_SITE_URL = 'https://kaspreadsheet.com';